import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import FixedPriceOverview from '../v2/pages/FixedPrice/FixedPriceOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'

export const fixedPriceBaseUrl = '/fixed-price/:action?'

export default function FixedPrices(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={fixedPriceBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) => (
                            <FixedPriceOverview
                                {...routeProps}
                                fileId={props.currentFile?.id}
                                file={props.currentFile}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockFixedPriceOverview-${props.currentFile?.id}-`}
                            />
                        )}
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
